import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const lookupAirportDataFn = httpsCallable(functions, 'lookupAirportData');
const lookupAirportServicesFn = httpsCallable(functions, 'lookupAirportServices');

export const fetchAirportData = async (airportCode, onStatus) => {
  try {
    onStatus?.('Starting airport data fetch...');
    const result = await lookupAirportDataFn({ airportCode });
    
    // Log timings and update status
    console.log('Airport Data Timings:', result.data.timings);
    if (result.data.timings) {
      const { validation, webScraping, aiProcessing, total } = result.data.timings;
      onStatus?.(`Web data fetched (${webScraping}ms)`);
      onStatus?.(`AI processing (${aiProcessing}ms)`);
      onStatus?.(`Airport data complete in ${total}ms`);
    }
    
    return result.data.data;
  } catch (error) {
    console.error('Error fetching airport data:', error);
    const timings = error.details?.timings;
    if (timings) {
      console.log('Error Timings:', timings);
      onStatus?.(`Error after ${timings.total}ms: ${error.message}`);
    }
    throw error;
  }
};

export const fetchAirportServices = async (airportCode, onStatus) => {
  try {
    onStatus?.('Starting FBO services fetch...');
    const result = await lookupAirportServicesFn({ airportCode });
    
    // Log timings and update status
    console.log('FBO Services Timings:', result.data.timings);
    if (result.data.timings) {
      const { validation, webScraping, aiProcessing, total } = result.data.timings;
      onStatus?.(`Web data fetched (${webScraping}ms)`);
      onStatus?.(`AI processing (${aiProcessing}ms)`);
      onStatus?.(`FBO services complete in ${total}ms`);
    }
    
    return result.data.data;
  } catch (error) {
    console.error('Error fetching airport services:', error);
    const timings = error.details?.timings;
    if (timings) {
      console.log('Error Timings:', timings);
      onStatus?.(`Error after ${timings.total}ms: ${error.message}`);
    }
    throw error;
  }
}; 